module.exports = __webpack_public_path__ + "img/card2.9986f932.png";